import { ApiClientException } from '../utils/apiClient';
import { createNachsorgeTasks, PractitionerServiceConfig } from './practitionerService';
import { ProfileApiException, ProfileServiceConfig, startNachsorge } from './profileService';

export type NachsorgeStartStage = 'tasks' | 'profile';

export class NachsorgeStartException extends Error {
    public readonly stage: NachsorgeStartStage;
    public readonly originalError: unknown;

    constructor(stage: NachsorgeStartStage, originalError: unknown) {
        super(originalError instanceof Error ? originalError.message : 'Unknown error');
        this.name = 'NachsorgeStartException';
        this.stage = stage;
        this.originalError = originalError;
    }
}

export interface NachsorgeStartConfig {
    questionnaire?: PractitionerServiceConfig;
    profile?: ProfileServiceConfig;
}

export async function startNachsorgeWorkflow(patientId: string, config?: NachsorgeStartConfig): Promise<void> {
    try {
        await createNachsorgeTasks(patientId, config?.questionnaire);
    } catch (error) {
        if (!(error instanceof ApiClientException && error.status === 409)) {
            throw new NachsorgeStartException('tasks', error);
        }
    }

    try {
        await startNachsorge(patientId, config?.profile);
    } catch (error) {
        if (!(error instanceof ProfileApiException && error.status === 409)) {
            throw new NachsorgeStartException('profile', error);
        }
    }
}
